
interface ENV {
  NODE_ENV: string | undefined;
  REACT_APP_ORGANISATIONS_API_URL: string | undefined;
  REACT_APP_COMPANY_API_URL:string | undefined;
  REACT_APP_SENTRY_DSN: string | undefined;
  REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS: string | undefined;
}

interface Config {
    NODE_ENV: string ;
    REACT_APP_ORGANISATIONS_API_URL: string;
    REACT_APP_COMPANY_API_URL:string;
    REACT_APP_SENTRY_DSN: string;
    REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS: string
}

const getConfig = (): ENV => {
  return {
    NODE_ENV: window._env_.NODE_ENV,
    REACT_APP_ORGANISATIONS_API_URL: window._env_.REACT_APP_ORGANISATIONS_API_URL,
    REACT_APP_COMPANY_API_URL: window._env_.REACT_APP_COMPANY_API_URL,
    REACT_APP_SENTRY_DSN: window._env_.REACT_APP_SENTRY_DSN,
    REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS: process.env.REACT_APP_SENTRY_TRACE_PROPAGATION_TARGETS,
  };
};

const getSanitzedConfig = (config: ENV): Config => {
  for (const [key, value] of Object.entries(config)) {
    if (value === undefined) {
        console.log(`Missing key ${key} in .env`);
    }
  }
  return config as Config;
};

const config = getConfig();

const sanitizedConfig = getSanitzedConfig(config);


export default sanitizedConfig;

